// Navigation helper for Redux Sagas
// This allows sagas to perform programmatic navigation without requiring history to be passed down
import { NavigateFunction, To, NavigateOptions } from 'react-router-dom'

let navigateFunction: NavigateFunction | null = null

export const setNavigateFunction = (navigate: NavigateFunction) => {
  navigateFunction = navigate
}

export const sagaNavigate: (to: To, options?: NavigateOptions) => void = (
  to: To,
  options?: NavigateOptions,
) => {
  if (!navigateFunction) {
    // eslint-disable-next-line no-console
    console.warn(
      'NavigationHelper: navigate function not initialized. Make sure NavigationSetup component is rendered.',
    )
    return
  }
  void navigateFunction(to, options)
}
